// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__VRALE","description":"MealItem_description__9J+uD","price":"MealItem_price__KwlZH"};